var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('v-btn',{attrs:{"dark":"","color":"pink"},on:{"click":function($event){_vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("add")]),_c('span',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }